export default __webpack_public_path__ + "static/media/rm4.efba212a.png";